import { Button, CircularProgress } from "@mui/material";
import React, { ReactNode } from "react";

interface BtnPropTypes {
  btnTitle?: string;
  endIcon?: ReactNode;
  className?: string;
  maxwidth?: string;
  bgColor?: string;
  textColor?: string;
  minwidth?: string;
  handleClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  loading?: boolean;
  isPdf?: boolean;
  children?: ReactNode; // Allow children prop
}

const CustomButtonFormStep = (props: BtnPropTypes) => {
  const {
    btnTitle,
    endIcon,
    maxwidth,
    minwidth,
    bgColor,
    textColor,
    className,
    handleClick,
    loading = false,
    isPdf = false,
    type = "button", // Default type is "button"
    disabled = false, // Default is not disabled
    children,
  } = props;
  const defaultBgColor = disabled || loading
  ? "#D3D3D3"
  : bgColor || "linear-gradient(98.24deg, #2977CC 4.13%, #1D538F 128.24%)"; // Default or custom color

const defaultTextColor = disabled || loading ? "#A9A9A9" : textColor || "#FFFFFF"; // Default or custom text color

  return isPdf ? (
    <span
      style={{
        maxWidth: maxwidth,
        minWidth: "191px",
        height: "52px",
        fontSize: "16px",
        fontWeight: 600,
        borderRadius: "8px",
        background: defaultBgColor,
        color: defaultTextColor,
    
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "10px 20px",
        cursor: disabled ? "not-allowed" : "pointer",
      }}
    >
      {children || btnTitle}
    </span>
  ) : (
    <Button
      variant="contained"
      type={type}
      endIcon={!loading ? endIcon : null}
      onClick={handleClick}
      disabled={disabled || loading}
      className={className}
      sx={{
        maxWidth: maxwidth,
        minWidth: "191px",
        height: "52px",
        fontSize: "16px",
        borderRadius: "8px",
        fontWeight: 600,
        background: defaultBgColor,
        color: defaultTextColor,
        cursor: disabled || loading ? "not-allowed" : "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {loading ? (
        <CircularProgress
          size={24}
          sx={{
            "& svg": {
              stroke: "url(#gradientColor)",
            },
          }}
        />
      ) : (
        children || btnTitle
      )}

      <svg width="0" height="0">
        <defs>
          <linearGradient id="gradientColor" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#2977CC" />
            <stop offset="100%" stopColor="#1D538F" />
          </linearGradient>
        </defs>
      </svg>
    </Button>
  );
};

export default CustomButtonFormStep;
